var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.667 21.5a4.332 4.332 0 0 1-4.334 4.333h-8.666A4.332 4.332 0 0 1 6.333 21.5V15c0-.596.488-1.083 1.084-1.083H9.55c.596 0 1.083.487 1.083 1.083v3.402c0 .801.444 1.538 1.148 1.917a2.127 2.127 0 0 0 2.2-.098l1.029-.671.953.64c.661.443 1.506.497 2.21.118a2.158 2.158 0 0 0 1.16-1.917V15c0-.596.487-1.083 1.083-1.083h2.166c.596 0 1.084.487 1.084 1.083v6.5zM25.292 10.667c0 1.191-.575 2.166-2.167 2.166H6.875c-1.657 0-2.167-.975-2.167-2.166V9.583c0-1.191.51-2.166 2.167-2.166h16.25c1.593 0 2.167.975 2.167 2.166v1.084z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.629 7.418A1.014 1.014 0 0 1 8.66 6.01L10.2 4.472c.4-.401 1.061-.401 1.462 0l2.947 2.946h-5.98zM15.38 7.418l2.948-2.946c.4-.401 1.061-.401 1.462 0l1.538 1.538c.39.39.401 1.007.033 1.408h-5.98zM18.219 15v3.39c0 .868-.964 1.387-1.68.9l-.974-.65a1.082 1.082 0 0 0-1.192 0l-1.018.672c-.715.476-1.668-.044-1.668-.9V15c0-.596.487-1.083 1.083-1.083h4.366c.596 0 1.083.487 1.083 1.083z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon-05.e3744d8fd500d2e5a4c64c064e574f36.svg";
export { ForwardRef as ReactComponent };